import { useState } from "react";
import { cn } from "~/features/common/utils/tailwind";
import config from "../../../../config";
import { PaceteqLogo } from "../../assets/PaceteqLogo";
import { OneRaceHubLogo } from "../../assets/OneRaceHubLogo";
import useLocalStorage from "../../hooks/useLocalStorage";
import { hasRequiredRoles } from "../../utils/loginChecks";
import ApiVersionCheck from "./ApiVersionCheck";
import ClientVersionCheck from "./ClientVersionCheck";
import NavCategory from "./components/NavCategory";
import ServerStatus from "./components/ServerStatus";
import SidebarCollapseButton from "./components/SidebarCollapseButton";
import SidebarItem from "./components/SidebarItem";
import {
  aiAndMl,
  configuration,
  homeItem,
  manager,
  operations,
  partsAndSpecs,
  useProfile,
} from "./components/SidebarNavigationLinks";
import { TimeRemaining } from "./components/TimeRemaining";
import { TimingServiceStatusIndicatorWrapper } from "./components/TimingServiceStatusIndicatorWrapper";
import { useAuth } from "../../context/AuthContext";

const Sidebar = () => {
  const [collapsed, setCollapsed] = useLocalStorage("sidebarIsCollapsed", false);
  const [isHelpEnabled] = useState(false);
  const profile = useProfile();
  const { isLoading: isLoadingAuth } = useAuth();

  const mainMenuCategories = [operations(), manager(), aiAndMl(), partsAndSpecs(), configuration()];

  return (
    <div className={cn(collapsed ? "w-[3rem]" : "w-56x w-[230px]", "flex flex-col", "print:hidden")}>
      <div className="flex h-0 flex-1 flex-col border-r border-gray-200 bg-gray-50/10 dark:border-gray-800 dark:bg-gray-900">
        <div className={cn(collapsed ? "pt-3" : "pb-4 pt-3", "flex flex-1 flex-col overflow-y-auto overflow-x-hidden")}>
          <OneRaceHubLogo
            testId="logo-sidebar"
            classNames={cn("mb-1", collapsed ? "h-4 w-4 mx-2.5" : "h-6 w-36 mx-3.5")}
            collapsed={collapsed}
          />
          <div
            className={cn(
              "ailgn-end mt-2 flex flex-wrap justify-start gap-x-1 gap-y-1.5",
              collapsed ? "px-1" : "px-3",
            )}>
            <TimingServiceStatusIndicatorWrapper collapsed={collapsed} />
            {config.get("session.showSessionTimeRemaining") === true && <TimeRemaining />}
            <ServerStatus collapsed={collapsed} />
          </div>
          <ApiVersionCheck collapsed={collapsed} />
          <ClientVersionCheck collapsed={collapsed} />
          <nav className="mt-2 flex-1" aria-label="Sidebar">
            {!isLoadingAuth && (
              <>
                <SidebarItem item={homeItem} collapsed={collapsed} isHelpEnabled={isHelpEnabled} />
                {mainMenuCategories.map((clusterItem, index) => {
                  return (
                    <NavCategory
                      key={clusterItem.name ?? index}
                      collapsed={collapsed}
                      item={clusterItem}
                      isHelpEnabled={isHelpEnabled}
                    />
                  );
                })}
              </>
            )}
          </nav>
        </div>
        <div className="mx-3.5 mt-3.5 mb-2 flex items-center justify-between">
          <PaceteqLogo
            classNames={cn(collapsed ? "h-6 w-6" : "h-6 w-26")}
            testId={"pt-logo-sidebar"}
            collapsed={collapsed}
          />
          {/* {!collapsed && (
            <HelpToggle
              isHelpEnabled={isHelpEnabled}
              setIsHelpEnabled={setIsHelpEnabled}
            />
          )} */}
        </div>
        <div className="border-t border-gray-300 p-0.5 hover:bg-gray-100 dark:border-gray-600 dark:hover:bg-gray-800">
          {profile.children.map(
            item =>
              hasRequiredRoles(item.restrictToRoles) && (
                <SidebarItem key={item.name} item={item} collapsed={collapsed} isHelpEnabled={isHelpEnabled} />
              ),
          )}
        </div>
        <SidebarCollapseButton collapsed={collapsed} setCollapsed={setCollapsed} />
      </div>
    </div>
  );
};

export default Sidebar;
